// extracted by mini-css-extract-plugin
export default {"trigger":"styles-module__VsdhQ","openIn":"styles-module__TtpfP","copyLabel":"styles-module__m85mp","option":"styles-module__erjFs","shortcut":"styles-module__SHJZa"};